import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
const { __ } = wp.i18n;
import {PanelBody,Panel,RangeControl,SelectControl,InputControl,ToggleControl,TextControl,Button,Icon} from "@wordpress/components";
import {imageUpload} from "./imageUploadPlaceholder";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck,
    __experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

const ALLOWED_BLOCKS = ["core/list","core/paragraph"];
const TEMPLATE = [["core/paragraph"]];


registerBlockType('theme-blocks/bio-block',{
    title:'Biography',
    category:'theme-blocks',
    icon:'text',
    attributes:{
      image:{type:'object',default:{id:0,url:`${VARIABLES.templateurl}/images/imagePlaceholder.png`}},
      imageRight:{type:'boolean',default:false},
      name:{type:'string'},
      title:{type:'string'},
      text:{type:'string'},
      
    },
    edit:function({attributes,setAttributes}){


      return (<Fragment>
        <div className="bioblock" {...useBlockProps({className:"bioblock"})}>
          <div className="image">
            {imageUpload({
              value:attributes.image,
              onSelect:(media)=>{
                setAttributes({image:media})
              }
            })}
          </div>
          <div className="text">
            <RichText tagName="h2" value={attributes.name} placeholder="Name" onChange={(v)=>setAttributes({name:v})}/>
            <RichText tagName="i" value={attributes.title} placeholder="Title/Positions" onChange={(v)=>setAttributes({title:v})}/>
            <InnerBlocks template={TEMPLATE} allowedBlocks={ALLOWED_BLOCKS}/>

          </div>
        </div>
      </Fragment>);
    },
    save:function({attributes}){
        return (<div className="bioblock">
        <div className="image">
          {attributes.image && attributes.image.url ? (<img src={attributes.image.url}/>) : (<></>)}
        </div>
        <div className="text">
          <RichText.Content tagName="h2" value={attributes.name}/>
          <RichText.Content tagName="i" value={attributes.title}/>
          <InnerBlocks.Content/>

        </div>
      </div>);
     
    }
});
